import { Tooltip, Typography } from "antd";
import { StyledFlex } from "../Table/index.styled";
import { Link } from "react-router-dom";
import { getRoute } from "@lib/helpers/RouteHelper";
import { ROUTES } from "@lib/constants";
import { useMemo } from "react";
import { Manager } from "@lib/types";

type Props = {
  manager: Manager;
  link?: boolean;
  titleMaxLength?: number;
};

export default function ManagerName({ manager, link }: Props) {
  const managerLink = useMemo(() => {
    return getRoute(ROUTES.MANAGER.DETAIL, {
      managerId: manager?.id,
    });
  }, [manager]);

  const managerName = useMemo(() => {
    if (!manager) return " N/A ";
    return (
      `${manager?.firstName || ""} ${manager?.lastName || ""}`.trim() ||
      manager?.email ||
      manager?.id
    );
  }, [manager]);

  if (!manager) return managerName;

  if (link && managerLink) {
    return (
      <StyledFlex style={{ gap: 5 }}>
        <Tooltip title={managerName}>
          <Typography.Text ellipsis={{ tooltip: managerName }}>
            <Link to={managerLink} style={{ cursor: "pointer" }}>
              {managerName}
            </Link>
          </Typography.Text>
        </Tooltip>
      </StyledFlex>
    );
  }

  return (
    <StyledFlex style={{ gap: 5 }}>
      <Tooltip title={managerName}>
        <Typography.Text ellipsis={{ tooltip: managerName }}>
          {managerName}
        </Typography.Text>
      </Tooltip>
    </StyledFlex>
  );
}
